import React from 'react'
import { Link } from 'react-router-dom'
import youtubeImage from "../../assets/images/brands/yt_logo_mono_light.png";
import fbImage from "../../assets/images/brands/facebook.png";
import twitchImage from "../../assets/images/brands/twitch.png";
import vimeo from "../../assets/images/brands/vimeo_logo_dark.png";
import twitter from "../../assets/images/brands/periscope.png";
import { useMediaQuery } from "react-responsive";

export default function TrustedBrandsPlain() {
    const isSmallDevice = useMediaQuery({query:"(max-width : 991px)"});
    return (
        

    
              <div className=' flex flex-column'>

                <div className='text-gray-400'> Suported Channels</div>
            
                <div className=" brands flex flex-wrap justify-start">
                  
                    <div className="brand border-none  w-1/5">
                        
                        <img alt="youtube" width="150" className="img-fluid" src={youtubeImage} />
                  
                    </div>
                    <div className="brand border-none  w-1/5">
                    <img alt="facebook" width="150" className="img-fluid" src={fbImage} />
                    </div>
                    <div className="brand border-none  w-1/5">
                    <img alt="twitch" width="150" className="img-fluid" src={twitchImage} />
       
                    </div>
                    <div className="brand border-none  w-1/5">
                    <img alt="vimeo" width="130" className="img-fluid" src={vimeo} />
        
                    </div>
                    <div className="brand border-none  w-1/5">
                    <img alt="vimeo" width="170" className="img-fluid" src={twitter} /> 
                   
                    </div>
                </div>
    
                </div>
      
    )
}
